import React from 'react'

const ArticleV2VideoYoutube = ({youtubeEmbedId}) => {
    if (!youtubeEmbedId) return <h2>Missing Youtube Embed ID</h2>

    return (
        <div>
            <iframe src={youtubeEmbedId} frameBorder={0}></iframe>

            <style jsx>{`
                div {
                    position: relative;
                    overflow: hidden;
                    width: 100%;
                    padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
                    margin-bottom: 20px;
                }
                
                /* Then style the iframe to fit in the container div with full height and width */
                iframe {
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    width: 100%;
                    height: 100%;
                    border: none;
                    outline: none;
                }
            `}</style>
        </div>
    )
}

export default ArticleV2VideoYoutube